import axios from 'axios'
import { getAPIUrl } from '../API'

export type MunicipalitiesByProvinceRequest = {
  provinceId: string
}

export interface Municipality {
  mun_name: string
  local_mun_code: string
}

export const getMunicipalitiesByProvince: (
  request: MunicipalitiesByProvinceRequest,
) => Promise<Municipality[]> = async (
  request: MunicipalitiesByProvinceRequest,
) => {
  const { data } = await axios.get(
    `${getAPIUrl()}/Common/province/${request.provinceId}/municipalities`,
    {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem('jwt')}`,
      },
    },
  )
  return data.data
}
